import { Validators } from '@angular/forms';
import { MultipleContractTypeSelectorComponent } from '@ordersnproducts/modules/one-click-order/components/contract-invoice-select/contract-invoice-select.component';
import { PurchaseOrderComponent } from '@ordersnproducts/modules/one-click-order/components/purchase-order/purchase-order.component';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickContractProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickPurchaseOrderProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-purchase-order.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickSetPurchaseOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-purchase-order.command';
import { OneClickPurchaseOrderValidator } from '@ordersnproducts/modules/one-click-order/validators/one-click-purchase-order.validator';
import { MAX_LENGTH_PO } from '@ordersnproducts/modules/order-builder/modules/location/constants/purchase-order.constants';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickHasResultProvider,
  OneClickNoResultProvider,
  OneClickContractPaymentProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import {
  OneClickNoResultHasInvoiceProvider,
  OneClickNoResultNoInvoiceProvider,
} from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract-type-result.provider';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-md-12 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-md-12 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-2 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-6 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickContractPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
  } as FieldConfig,
  {
    type: PurchaseOrderComponent,
    name: OneClickPreviewField.PurchaseOrder,
    label: 'views.one_click.purchase_order',
    dynamicEffects: [OneClickJobsiteSalesAreaFromOrderEffects],
    onChange: [OneClickSetPurchaseOrder],
    hidden: OneClickHasResultProvider,
    placeholder: 'views.one_click.enter_purchase_order',
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    validation: [Validators.maxLength(MAX_LENGTH_PO)],
    asyncValidators: [OneClickPurchaseOrderValidator.validator],
  } as FieldConfig,
  {
    type: MultipleContractTypeSelectorComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickContractEffects, ContractBalanceEffects],
    label: '',
    containerClassNames: ['col-md-12 mt-3'],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultHasInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.contract',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultNoInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.invoice',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PurchaseOrder,
    hidden: OneClickNoResultProvider,
    text: OneClickPurchaseOrderProvider,
    label: 'views.one_click.purchase_order',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
];
